var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"reduceheight"}},[(_vm.scribbleActive)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
        callback: _vm.scribbleVisible,
        once: true,
        intersection: {
          rootMargin: '0px 0px -20% 0px'
        }
      }),expression:"{\n        callback: scribbleVisible,\n        once: true,\n        intersection: {\n          rootMargin: '0px 0px -20% 0px'\n        }\n      }"}],class:_vm.$style.scribble,attrs:{"id":"scribble"}}),_c('div',{class:_vm.$style.scribbleWrapper},[(_vm.animationStarted)?_c('plp-tutorial-scribble-cursor'):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }